import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UrlParamsService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Get URL parameters in a way that works with SSR
   * Returns empty string on server, actual params on client
   */
  getSearchParams(): string {
    if (!isPlatformBrowser(this.platformId)) {
      return '';
    }
    return window.location.search;
  }

  /**
   * Get a specific URL parameter by name
   * Returns null if not found or on server
   */
  getParam(name: string): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  /**
   * Get all URL parameters as an object
   * Returns empty object on server
   */
  getAllParams(): Record<string, string> {
    if (!isPlatformBrowser(this.platformId)) {
      return {};
    }

    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};

    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }

    return params;
  }

  /**
   * Clear a specific URL parameter by name
   * Returns null if not found or on server
   */
  clearParam(name: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(name);
    window.history.replaceState(
      {},
      '',
      window.location.pathname + '?' + urlParams.toString()
    );
  }

  /**
   * Clear all URL parameters
   * Returns null if not found or on server
   */
  clearAllParams(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.history.replaceState({}, '', window.location.pathname);
  }
}
